import { Text, View } from '@react-pdf/renderer'
import { sanitizeForPdf } from 'features/reporting/pdfGeneration/utils/formatters'
import type React from 'react'

import { PDF_HEADING_MIN_PRESENCE, PdfStyles } from './pdfStyles'

export interface PdfTableRow {
  cells: ReadonlyArray<string>
}

export interface PdfTableData {
  headers: ReadonlyArray<string>
  rows: ReadonlyArray<PdfTableRow>
  /** Optional column width fractions that sum to ~1 */
  columnWidths?: ReadonlyArray<number>
}

export const PdfTable: React.FC<{ table: PdfTableData }> = ({ table }) => {
  const widths =
    table.columnWidths ??
    table.headers.map(() => 1 / Math.max(table.headers.length, 1))

  return (
    <View style={PdfStyles.table}>
      <View
        style={PdfStyles.tableHeaderRow}
        wrap={false}
        minPresenceAhead={PDF_HEADING_MIN_PRESENCE}>
        {table.headers.map((header, i) => (
          <Text
            key={i}
            style={[
              PdfStyles.tableHeaderCell,
              { width: `${widths[i] * 100}%` },
            ]}>
            {sanitizeForPdf(header)}
          </Text>
        ))}
      </View>
      {table.rows.map((row, rowIndex) => (
        <View
          key={rowIndex}
          wrap={false}
          style={
            rowIndex % 2 === 0 ? PdfStyles.tableRow : PdfStyles.tableRowAlt
          }>
          {row.cells.map((cell, cellIndex) => (
            <Text
              key={cellIndex}
              style={[
                PdfStyles.tableCell,
                { width: `${widths[cellIndex] * 100}%` },
              ]}>
              {sanitizeForPdf(cell)}
            </Text>
          ))}
        </View>
      ))}
    </View>
  )
}
